const AUTHORIZATION_HEADER = 'Authorization';
/**
 * A header for revoking user's permissions by
 * performing the operation with a role that has less
 * privileges.
 */
const USER_ROLE_HEADER = 'X-Shw-Api-User-Role';
/**
 * Header for specifying the user's Account ID when
 * performing the request. For multi-account users this header
 * should be used to specify the correct Account.
 */
const ACCOUNT_HEADER = 'X-Shw-Account';
/**
 * A header that directs API not to send HTTP Authentication
 * challenge in case of missing auth information.
 */
const NO_CHALLENGE_HEADER = 'X-No-Challenge';
/**
 * Perform request to Showell API
 *
 */
export default async function fetchApi({ url, body, accessToken, method, headers, accountId, userRole, agent, onBeforeRequest, }) {
    const requestHeaders = new Headers(headers);
    populateHeaders(requestHeaders, {
        accessToken,
        accountId,
        userRole,
    });
    const options = {
        method,
        headers: requestHeaders,
        body,
        ...(agent ? { agent } : undefined),
    };
    onBeforeRequest?.({ payload: { ...options, url } });
    return await fetch(url, options);
}
export function populateHeaders(headers, { accessToken, accountId, userRole }) {
    if (accessToken) {
        headers.append(AUTHORIZATION_HEADER, 'Bearer ' + accessToken);
    }
    if (accountId) {
        headers.append(ACCOUNT_HEADER, accountId);
    }
    if (userRole) {
        headers.append(USER_ROLE_HEADER, userRole);
    }
    headers.append(NO_CHALLENGE_HEADER, 'true');
    return headers;
}
